<div class="bs-range-input">
  <bs-input [disabled]="disabled" [(ngModel)]="range.from" (ngModelChange)="changes()" placeholder="from"></bs-input>
  <span>&ndash;</span>
  <bs-input [disabled]="disabled" [(ngModel)]="range.to" (ngModelChange)="changes()" placeholder="to"></bs-input>
</div>
